import { ObjectForSelection } from '../../types/interfaces/ObjectForSelection';
import { VerificationFunctions } from '../../types/interfaces/VerificationFunctions';
import IApiCalls from '../api/interfaces/apiCalls';

import BaseService from './BaseService';
import ServiceResult from './interfaces/ServiceResult';
import IVerificationFunctionsService from './interfaces/VerificationFunctionsService';

class VerificationFunctionsService
  extends BaseService<VerificationFunctions>
  implements IVerificationFunctionsService
{
  constructor(apiCalls: IApiCalls) {
    super(apiCalls, 'VerificationFunctions');
  }

  getForSelection(): ServiceResult<ObjectForSelection[] | undefined> {
    const apiCalls = this._apiCalls.beginApiCalls();
    return {
      result: apiCalls.VerificationFunctions.getForSelection(),
      cancel: apiCalls.cancelAllCalls
    };
  }
}

export default VerificationFunctionsService;
